import React, { useContext, useEffect } from "react";
import moment from "moment";
import { ProyectosContext } from "../../context/ProyectosContext";
import { quitarClaveNombre } from "../../utils/destajos";
import TextoExpandible from "../common/TextoExpandible";
import { conSigno } from "../../utils";

// Avances of the day of `fecha`, one row per concepto / subdestajo with the net
// delta of the day (several moves of the same element collapse into one).
const AvancesDia = ({ idProyecto, fecha }) => {
  const { avancesDia, getAvancesDia } = useContext(ProyectosContext);

  useEffect(() => {
    const desde = moment(fecha).startOf("day").toISOString();
    const hasta = moment(fecha).startOf("day").add(1, "day").toISOString();
    getAvancesDia(idProyecto, desde, hasta);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idProyecto, fecha]);

  const renderDelta = (avance) => {
    const pct = Number(avance.delta_porcentaje) || 0;
    const color =
      pct > 0 ? "text-success" : pct < 0 ? "text-danger" : "text-muted";
    return (
      <div className="text-end flex-shrink-0 ms-3">
        <div className={`bold ${color}`} style={{ fontSize: "1.15rem" }}>
          {conSigno(pct)}%
        </div>
        {Number(avance.por_cantidad) === 1 && (
          <div className="small text-muted text-nowrap">
            {conSigno(avance.delta_cantidad)} {avance.unidad || ""}
          </div>
        )}
      </div>
    );
  };

  const renderAvance = (avance) => {
    const nombre = quitarClaveNombre(
      avance.subdestajo || avance.destajo || avance.partida,
      avance.clave
    );
    const padre = avance.subdestajo
      ? avance.destajo
      : avance.destajo
      ? avance.partida
      : null;
    return (
      <div
        key={`${avance.tipo}-${avance.idElemento}`}
        className="card border shadow-sm mb-2"
        style={{ borderRadius: 10 }}
      >
        <div className="card-body p-3 d-flex align-items-center">
          <div className="flex-grow-1" style={{ minWidth: 0 }}>
            <TextoExpandible>
              {avance.clave && (
                <span className="text-muted me-1">[{avance.clave}]</span>
              )}
              <span className="bold">{nombre}</span>
            </TextoExpandible>
            {padre && (
              <div className="small text-muted">
                <i className="fa fa-folder me-1" />
                {padre}
              </div>
            )}
            <div className="small text-muted mt-1">
              <i className="fa fa-clock me-1" />
              {moment(avance.ultimo).format("HH:mm")}
              {avance.usuarios && (
                <>
                  {" · "}
                  <i className="fa fa-user-circle me-1" />
                  {avance.usuarios}
                </>
              )}
              {Number(avance.movimientos) > 1 && (
                <span className="badge bg-light text-dark border ms-2">
                  {avance.movimientos} movimientos
                </span>
              )}
            </div>
          </div>
          {renderDelta(avance)}
        </div>
      </div>
    );
  };

  const renderAvances = () => {
    if (avancesDia.length === 0) {
      return (
        <div className="text-center text-muted py-5">Sin avancesDia este día.</div>
      );
    }
    return avancesDia.map(renderAvance);
  };

  if (avancesDia === undefined) return <div className="spinner-border" />;
  if (!Array.isArray(avancesDia)) {
    return (
      <p className="text-muted">No se pudieron cargar los avancesDia del día.</p>
    );
  }

  return (
    <div>
      <p className="text-muted small mb-3">
        <i className="fa fa-calendar-day me-1" />
        {moment(fecha).format("DD MMM YYYY")} · {avancesDia.length}{" "}
        {avancesDia.length === 1 ? "elemento" : "elementos"} con avance. Cada
        concepto aparece una vez con el cambio neto del día.
      </p>
      {renderAvances()}
    </div>
  );
};

export default AvancesDia;
